import React from 'react';
import { Icon } from './icons';

interface Props {
  number: number;
  text: string;
  meta: string;
  moved?: boolean;
  canUp: boolean;
  canDown: boolean;
  onUp: () => void;
  onDown: () => void;
  onEdit?: () => void;
  onRemove: () => void;
  /** «Убрать из теста» в мастере, «Убрать» на странице теста. */
  removeLabel: string;
  /** Тест в архиве: строка без кнопок. */
  readOnly?: boolean;
}

/** Строка вопроса со стрелками порядка (макет v6). */
export const QuestionRow: React.FC<Props> = ({
  number, text, meta, moved = false, canUp, canDown, onUp, onDown, onEdit, onRemove, removeLabel, readOnly = false,
}) => (
  <div className={`tw-qrow${moved ? ' tw-qrow-moved' : ''}`}>
    <span className="tw-qnum">{number}</span>
    <span className="tw-qbody">
      <span className="tw-qtext">{text}</span>
      <span className="tw-qmeta">{meta}</span>
      {moved && <span className="tw-tag">Перемещён</span>}
    </span>
    {!readOnly && (
      <span className="tw-order">
        <button type="button" className="tw-btn tw-btn-small" aria-label={`Поднять выше вопрос: ${text}`} disabled={!canUp} onClick={onUp}>
          <Icon name="up" size={22} />
          Выше
        </button>
        <button type="button" className="tw-btn tw-btn-small" aria-label={`Опустить ниже вопрос: ${text}`} disabled={!canDown} onClick={onDown}>
          <Icon name="down" size={22} />
          Ниже
        </button>
        {onEdit && (
          <button type="button" className="tw-btn tw-btn-small" aria-label={`Изменить вопрос: ${text}`} onClick={onEdit}>
            <Icon name="pencil" size={22} />
            Изменить
          </button>
        )}
        <button type="button" className="tw-btn tw-btn-small" aria-label={`Убрать из теста вопрос: ${text}`} onClick={onRemove}>
          <Icon name="x" size={22} />
          {removeLabel}
        </button>
      </span>
    )}
  </div>
);
